import React from 'react';
import './Switch.scss';

interface SwitchProps {
  checked?: boolean;
  disabled?: boolean;
  handleChange: (e: boolean) => void;
}

export const Switch: React.FC<SwitchProps> = ({
  checked,
  disabled,
  handleChange
}) => {
  const randomNumber = Math.ceil(Math.random() * 1000) * Date.now();
  return (
    <div
      className={`ads-switch ${disabled ? 'ads-switch--disabled' : ''}`}
      data-testid="ads-switch"
    >
      <label
        className="ads-switch__label"
        htmlFor={`ads-switch--${randomNumber}`}
      >
        <span>.</span>
        <div className="ads-switch__switch">
          <input
            className="ads-switch__input"
            id={`ads-switch--${randomNumber}`}
            type="checkbox"
            checked={checked}
            aria-checked={checked}
            role="switch"
            disabled={disabled}
            data-testid="ads-switch__input"
            onChange={(e) => handleChange(e.target.checked)}
          />
          <span className="ads-switch__slider" />
        </div>
      </label>
    </div>
  );
};
